module.exports = __webpack_public_path__ + "img/icon_pen.c86a3d0b.svg";